import * as React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { Leitores } from '../../services/http'
import { MenuItem } from '@mui/material'
import { func } from 'prop-types'

export default function LeitorAutocomplete({ onChange, ...rest }) {
  const [leitores, setLeitores] = React.useState([''])
  const [leitor, setLeitor] = React.useState('')
  let typingTimer = ''

  React.useEffect(() => {
    getLeitores()
  }, [])

  async function getLeitores(params) {
    try {
      const { data } = await Leitores().show({
        includes: 'user',
        'includes[user][ativo]': true,
        ...params
      })
      setLeitores(data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const RenderOptions = (props, option) => {
    return (
      <MenuItem value={option?.id || ''} {...props} key={option?.id || 0}>
        {option !== undefined && option?.user?.name}
      </MenuItem>
    )
  }

  function getByTitle(event) {
    clearTimeout(typingTimer)
    typingTimer = setTimeout(() => {
      getLeitores({
        'includes[user][name]': event.target.value.toUpperCase() + '%'
      })
    }, 1000)
  }

  return (
    <Autocomplete
      value={leitor?.id}
      onChange={event => {
        setLeitor(event.target.value)
        onChange(event.target.value)
      }}
      size="small"
      onInput={event => getByTitle(event)}
      options={leitores}
      getOptionLabel={option => option?.user?.name || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => <TextField {...params} label="Leitor" />}
      renderOption={RenderOptions}
      {...rest}
    />
  )
}
LeitorAutocomplete.propTypes = {
  onChange: func
}
